import React from 'react';
import { withRouter } from 'react-router-dom';
import fileSaver from 'file-saver';
// ANTD
import Menu from 'antd/lib/menu';
import Dropdown from 'antd/lib/dropdown';
import Icon from 'components/common/Icon';
import message from 'antd/lib/message';
import notification from 'antd/lib/notification';
// APOLLO
import { graphql, compose } from 'react-apollo';
import generateComponentAsPDF from 'ApolloClient/Mutations/generateComponentAsPDF'
import sendInvoiceReminder from 'ApolloClient/Mutations/sendInvoiceReminder'
import deleteInvoice from 'ApolloClient/Mutations/deleteInvoice'
import markAsPaid from 'ApolloClient/Mutations/markAsPaid'
import markAsUnpaid from 'ApolloClient/Mutations/markAsUnpaid'
//
import PDFHelpers from 'lib/helpers/PDFHelpers';
import ClipboardButton from 'react-clipboard.js';
import invoicesByClientIdQuery from 'ApolloClient/Queries/invoicesByClientId'
import invoiceFragment from 'ApolloClient/Fragments/invoiceFragment'


const ICON_STYLE = { marginRight: 6, fontSize: 17 };



export class ActionMenu extends React.PureComponent {
  state = {
    loading: false
  };

  onDownloadPDF = () => {
    // mark as loading
    this.setState({ loading: true });

    const now = new Date();
    const variables = {
      params: {
        type: 'invoice',
        _id: this.props.record._id,
        fileName: `document_${this.props.record._id}_${now.toISOString()}.pdf`
      }
    };

    this.props
      .generateComponentAsPDF({ variables })
      .then(({ data }) => {
        const { fileName, base64 } = data.generateComponentAsPDF;
        const blob = PDFHelpers.base64ToBlob(base64);
        fileSaver.saveAs(blob, fileName);
        message.success('PDF downloaded!', 4);
        this.setState({ loading: false });
      })
      .catch(err => console.log(err));
  };

  onSendReminder = () => {
    const { record } = this.props; // destructure
    this.setState({ loading: true }); // start loader
    // call mutation
    this.props
      .sendInvoiceReminder({ variables: { _id: record._id } })
      .then(() => {
        this.setState({ loading: false });
        notification.success({ message: 'We sent a reminder email sent!' });
      })
      .catch(err => {
        this.setState({ loading: false });
        message.error(err.message);
      });
  };

  updateAfterDeleteInvoiceMutation = (proxy, { data }) => {

    // will update local apollo cache after the mutation. see apollo docs.
    const localData = proxy.readQuery({
      query: invoicesByClientIdQuery,
      variables: {
        _id: this.props.record.clientId,
      },
    });
    // filter out the client we just deleted form the local apollo cache
    let newInvoices = localData.invoicesByClientId.filter(item => item._id !== this.props.record._id);
    // overwrite the apollo cache with filtered array
    proxy.writeQuery({
      query: invoicesByClientIdQuery,
      variables: {
        _id: this.props.record.clientId,
      },
      data: {
        invoicesByClientId: newInvoices,
      },
    });

  }

  onDelete = async () => {
    const { record } = this.props; // destructure
    this.setState({ loading: true }); // start loader
    // call mutation\

    try {
      await this.props.deleteInvoice({ 
        update: this.updateAfterDeleteInvoiceMutation, 
        variables: { _id: record._id } 
      });
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
      return message.error(err.message);
    }
    notification.success({ message: `Invoice successfully deleted!` });
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1500);
  };
  
  updateAfterMarkAsPaidMutation = (proxy, { data }) => {

    // will update local apollo cache after the mutation. see apollo docs.
    // filter out the client we just deleted form the local apollo cache
    // overwrite the apollo cache with filtered array
    proxy.writeFragment({
      fragment: invoiceFragment,
      fragmentName: 'invoiceFragment',
      id: this.props.record._id,
      data: {
        ...data.markAsPaid,
        status: 'PAID'
      }
    });

  }

  onMarkUnpaid = async () => {
    const { record } = this.props; // destructure
    this.setState({ loading: true }); // start loader

    try {
      await this.props.markAsUnpaid({ update: (proxy, { data }) =>{
        proxy.writeFragment({
          fragment: invoiceFragment,
          fragmentName: 'invoiceFragment',
          id: this.props.record._id,
          data: {
            ...data.markAsUnpaid,
            status: 'SENT'
          }
        });
      }, variables: { _id: record._id } });
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
      return message.error(err.message);
    }

    notification.success({
      message: `Invoice successfully marked as unpaid!`
    });

    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
  };

  markAsPaid = async () => {
    const { record, markAsPaid } = this.props; // destructure
    this.setState({ loading: true }); // start loader

    try {
      await markAsPaid({ update: this.updateAfterMarkAsPaidMutation, variables: { _id: record._id } });
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
      return message.error(err.message);
    }

    notification.success({
      message: `Invoice successfully marked as paid!`
    });

    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
  };

  handleMenuClick = ({ key }) => {
    switch (key) {
      case '1':
        return this.onSendReminder();
      case '2':
        return this.onDownloadPDF();
      case '3':
        return this.markAsPaid();
      case '4':
        return this.onDelete();
      case 'markUnpaid':
        return this.onMarkUnpaid();
      default:
        return null;
    }
  };

  render() {
    const { status } = this.props.record;

    return (
      <div style={s.container}>
        <Dropdown
          trigger={['click']}
          overlay={
            <Menu onClick={this.handleMenuClick}>
              {status === 'SENT' && (
                <Menu.Item key="1">
                  <Icon type="mail" style={ICON_STYLE} />
                  Send Reminder
                </Menu.Item>
              )}
              <Menu.Item key="2">
                <Icon type="cloud-download" style={ICON_STYLE} />
                Download Invoice
              </Menu.Item>
              {status !== 'PAID' && (
                <Menu.Item key="3">
                  <Icon type="like-o" style={ICON_STYLE} />
                  Mark as Paid
                </Menu.Item>
              )}
              {status !== 'PAID' && (
                <Menu.Item key="4">
                  <Icon type="delete" style={ICON_STYLE} />
                  Delete Invoice
                </Menu.Item>
              )}
              {status === 'PAID' && (
                <Menu.Item key="markUnpaid">
                  <Icon type="delete" style={ICON_STYLE} />
                  Mark Unpaid
                </Menu.Item>
              )}
              <Menu.Item key="5">
                <ClipboardButton
                  component="span"
                  onSuccess={() =>
                    message.success(
                      `Link copied to clipboard: ${`${process.env.REACT_APP_PUBLIC_URL}invoice/pay/${
                        this.props.record._id
                      }`}`,
                      10
                    )
                  }
                  data-clipboard-text={`${process.env.REACT_APP_PUBLIC_URL}invoice/pay/${
                    this.props.record._id
                  }`}
                >
                  <Icon type="share-alt" style={ICON_STYLE} />
                  Share Link
                </ClipboardButton>
              </Menu.Item>
            </Menu>
          }
        >
          {this.state.loading ? (
            <Icon type="loading" style={s.loadingIcon} />
          ) : (
            <Icon type="ellipsis" style={{ fontSize: 20, fontWeight: 600 }} />
          )}
        </Dropdown>
      </div>
    );
  }
}

const s = {
  loadingIcon: {
    fontSize: 20,
    color: '#f29980',
    fontWeight: 600
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  menuItem: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
  }
};

export default compose(
  graphql(generateComponentAsPDF, { name: 'generateComponentAsPDF' }),
  graphql(sendInvoiceReminder, { name: 'sendInvoiceReminder' }),
  graphql(deleteInvoice, { name: 'deleteInvoice' }),
  graphql(markAsPaid, { name: 'markAsPaid' }),
  graphql(markAsUnpaid, { name: 'markAsUnpaid' })
)(withRouter(ActionMenu));



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientInvoices/ActionMenu/index.js